module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aneck5-449729e7017f65b66dbdd5f2130a00cd.jpg";